var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Input from "@mui/joy/Input";
import layoutComponentsDictionary from "../layoutComponentsDictionary";
import { useTranslation } from "react-i18next";
import { FormSettingsContext } from "../../utils";
import { useContext } from "react";
import { Spacing } from "../../properties/spacing";
import { Color } from "../../properties/color";
/**
 * Settings of Panels
 * @param moduleName
 * @param layoutName
 * @param packageName
 */
export function LayoutPanelsSettings(_a) {
    var moduleName = _a.moduleName, layoutName = _a.layoutName, packageName = _a.packageName;
    var t = useTranslation(["common", moduleName]).t;
    var _b = useContext(FormSettingsContext), settings = _b.settings, editedSettings = _b.editedSettings;
    var current = settings.currentComponent || {};
    var s = current.settings || {};
    var label = s.label || "";
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "p-4 pb-16" }, { children: _jsxs("div", { children: ["ETC LAYOUT::Panel", _jsx("br", {}), _jsx("label", { children: "Title" }), _jsx(Input, { type: "text", size: "sm", defaultValue: label, value: label, onChange: function (event) {
                            editedSettings(__assign(__assign({}, settings), { currentComponent: __assign(__assign({}, current), { settings: {
                                        label: event.target.value,
                                    } }), isDirty: true, newLayout: settings.newLayout }));
                        } }), _jsx(Spacing, {}), _jsx(Color, {})] }) })) }));
}
layoutComponentsDictionary.registerLayoutComponent("panel-settings", LayoutPanelsSettings);
